export default "__VITE_ASSET__DPmMs622__"